import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotiService } from '@app/noti.service';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service'
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare var $: any,moment : any
enum CustomerType {
  Company = 1,
  Person = 2
};

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  submitted = false
  isShift = false
  combinedAddressList: any
  combinedAddressListEn: any
  regisType = "n"
  Type: CustomerType = CustomerType.Person;
  companyTypeList: any
  form: FormGroup
  personalTypeList: any

  isConsentAccept = false
  isRequiredRegisId = false

  isShownConsent = false

  isDup = false
  isSuccess = false

  PortalLogin: any;
  contactData: any;

  isForeign = false
  strictIdCard = true

  cookieData: any
  cookieData2: any
  isCrisis = false

  isIdCardValid = true
  isNotInDROS = false
  authFname = ""
  authLname = ""
  authIdcard = ""

  lang = "th"
  menuEnabled = false

  private notiSubscription: Subscription;

  constructor(
    private util: UtilService,
    private api: ApiService,
    private fb: FormBuilder,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private notiService: NotiService
  ) {
    this.form = this.fb.group({
      contactid: "",

      dpa_companyname: "",
      dpa_companytypeid: "",
      dpa_registrationid: "",

      dpa_authorizedperson: "",
      dpa_authorizedperson_idcard: "",
      dpa_authorizedperson_telephone: "",

      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      dpa_personaltypeid: '',
      dpa_personaltypeidname: "",
      birthdate: "",
      dpa_idcard: ['', Validators.required],
      dpa_accountno: ['', Validators.required],
      emailaddress1: ['', this.emailValidator],
      telephone1: ['', Validators.required],

      dpa_passport: "",

      dpa_contact_homeno: ['', Validators.required],
      dpa_contact_moo: "",
      dpa_contact_street: "",

      dpa_contact_subdistict: ['', Validators.required],
      dpa_contact_distict: "",
      dpa_contact_province: "",
      dpa_contact_postcode: "",
      dpa_contact_country: "",

      dpa_contact_subdistictname: "",
      dpa_contact_distictname: "",
      dpa_contact_provincename: "",
      dpa_contact_postcodename: "",
      dpa_contact_countryname: "",
      dpa_allowemail: false,
      dpa_allowsms: false,
      dpa_portalflag: true
    });
  }

  ngOnDestroy() {
    if (this.notiSubscription) {
      this.notiSubscription.unsubscribe();
    }
  }

  async ngOnInit() {
    let thisTs = this
    this.util.ShowWaiting(true)

    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    this.cookieData2 = JSON.parse(sessionStorage.getItem("dpa_portalThaiID"))
    if (this.cookieData == null) {
      this.cookieData = {}
    }

    if (this.cookieData2 != null) {
      
        this.form.controls["firstname"].setValue(this.cookieData2.data.given_name)
        this.form.controls["lastname"].setValue(this.cookieData2.data.family_name)
        this.form.controls["dpa_idcard"].setValue(this.cookieData2.data.pid)
        this.form.controls["telephone1"].setValue(this.cookieData2.data.phone)
        this.form.controls["emailaddress1"].setValue(this.cookieData2.data.email)
        this.form.controls["dpa_accountno"].setValue(this.cookieData2.data.accountno)

        //let addr = this.cookieData2.address.split(" ");

        //$(".select2").val(addr[2] + "|" + addr[3] + "|" + addr[4] + "|" + addr[5] + "|ประเทศไทย").trigger('change')
        //this.formControl["dpa_contact_subdistict"].setValue(addr[1])
        //this.formControl["dpa_contact_distict"].setValue(addr[2])
        //this.formControl["dpa_contact_province"].setValue(addr[3])
        //this.formControl["dpa_contact_postcode"].setValue(addr[4])
        //this.formControl["dpa_contact_country"].setValue("ประเทศไทย")
      }

    let config: any = await this.apiService.get("master", "configuration")
    let crisisConfig: any = config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      this.cookieData.isCrisis = true
      this.isCrisis = true
      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
    }
    else {
      this.cookieData.isCrisis = false
      this.isCrisis = false
      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
    }

    let menuList: any = await this.api.get("master", "customerPortalMenuSetting")
    let thisMenu: any = this.util.getMenuObj(menuList, "11", this.isCrisis)
    if (!thisMenu.show) {
      this.util.ShowWaiting(false)
      setTimeout(() => {
        this.router.navigate(["mainmenu/index"])
      }, 500);
      return
    }
    else {
      this.menuEnabled = true
    }

    // let tmpLang = this.util.GetCurrentLang()
    // this.lang = tmpLang.substring(0,2)
    // this.util.SetLanguage(tmpLang)

    this.util.InitValidation()

    
      // boy add
        
      let para = "dpaCode=PRIVACY_POLICY";
      let tmp: any = await this.api.get("crmservice", "getPolicy", para); 
      if(!this.util.IsNullOrUndefined(tmp.policyDetail))
        {
          $("#regPolicy").html(tmp.policyDetail);
        }
      // boy add

    if (this.lang == "th") {
      $(".select2-en").hide()
      $(".select2-th").show()
    }
    else {
      $(".select2-th").hide()
      $(".select2-en").show()
    }

    this.notiSubscription = this.notiService.message.subscribe(_lang => {
      this.lang = _lang
      if (this.lang == "th") {
        $(".select2-en").hide()
        $(".select2-th").show()
      }
      else {
        $(".select2-th").hide()
        $(".select2-en").show()
      }
      //this.bindAddress(this.lang)
    });

    let type: string = this.activatedRoute.snapshot.queryParams['regisType'];

    if (type == "c") {
      this.regisType = "c"
      this.Type = CustomerType.Company
    }
    else {
      this.regisType = "n"
      this.Type = CustomerType.Person
    }

    function matchCustom(params: any, data: any) {
      if ($.trim(params.term) === '') {
        return data;
      }

      if (typeof data.text === 'undefined') {
        return null;
      }

      if (params.term.length > 1) {
        let cris = params.term.split(" ")
        let found = true
        for (var i = 0; i < cris.length; i++) {
          if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
            found = false;
            return null
          }
        }
        if (found) {
          return data;
        }
      }
      return null;
    }


    $('.select2th').select2({
      matcher: matchCustom,
      placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
    });

    $('.select2en').select2({
      matcher: matchCustom,
      placeholder: "Please select your address."
    });

    $(".select2").on("change", function (e: any) {
      thisTs.addressChange(e.target.value)
    })

    this.initDropdown()
  }

  async initDropdown() {

    if (this.regisType == "n") {
      Observable.forkJoin(
        this.apiService.get("master", "personalType"),
        this.apiService.getMasterAddress()
      ).subscribe(
        data => {
          this.personalTypeList = data[0]
          this.combinedAddressList = data[1]

          this.setAddressEn()
          this.util.ShowWaiting(false)
        },
        err => console.error(err)
      );
    }
    else {
      Observable.forkJoin(
        this.api.get("master", "companyType"),
        this.apiService.getMasterAddress(),
      ).subscribe(
        data => {
          this.companyTypeList = data[0]
          this.combinedAddressList = data[1]
          this.setAddressEn()
          this.util.ShowWaiting(false)
        },
        err => console.error(err)
      );
    }

    this.util.ShowWaiting(false)
  }

  setAddressEn() {
    if (this.combinedAddressList != null && this.combinedAddressList.length > 0) {
      this.combinedAddressListEn = this.combinedAddressList.slice().sort(function (a: any, b: any) {
        if (a.text_eng < b.text_eng) {
          return -1;
        }
        if (a.text_eng > b.text_eng) {
          return 1;
        }
        return 0;
      });
    }
  }

  get formControl() {
    return this.form.controls;
  }

  get email() {
    return this.form.value.emailaddress1.trim()
  }

  emailValidator(control: any) {
    if (control.value) {
      const matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

  addressChange(value: any) {
    let selected = this.combinedAddressList.filter((a: any) => a.id == value)
    if (selected != null && selected.length > 0) {
      let values = selected[0].id.split("|")
      let texts: any
      if (this.lang == "th") {
        texts = selected[0].text.split(" | ")
      }
      else {
        texts = selected[0].text_eng.split(" | ")
      }

      this.formControl["dpa_contact_subdistict"].setValue(values[0])
      this.formControl["dpa_contact_distict"].setValue(values[1])
      this.formControl["dpa_contact_province"].setValue(values[2])
      this.formControl["dpa_contact_postcode"].setValue(values[3])
      this.formControl["dpa_contact_country"].setValue(values[4])

      this.formControl["dpa_contact_subdistictname"].setValue(texts[0])
      this.formControl["dpa_contact_distictname"].setValue(texts[1])
      this.formControl["dpa_contact_provincename"].setValue(texts[2])
      this.formControl["dpa_contact_postcodename"].setValue(texts[3])
      this.formControl["dpa_contact_countryname"].setValue(texts[4])
    }
    else {
      this.formControl["dpa_contact_subdistict"].setValue("")
      this.formControl["dpa_contact_distict"].setValue("")
      this.formControl["dpa_contact_province"].setValue("")
      this.formControl["dpa_contact_postcode"].setValue("")
      this.formControl["dpa_contact_country"].setValue("")

      this.formControl["dpa_contact_subdistictname"].setValue("")
      this.formControl["dpa_contact_distictname"].setValue("")
      this.formControl["dpa_contact_provincename"].setValue("")
      this.formControl["dpa_contact_postcodename"].setValue("")
      this.formControl["dpa_contact_countryname"].setValue("")
    }
  }

  clear() {
    this.submitted = false
    $('#dob').val('')
    this.form.reset()
    $('.select2').val('').trigger('change');
  }

  async preregister()
  {
    let thisTs = this;
    
    let dpa_idcard = "เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี : " + this.form.controls["dpa_idcard"].value + "<br>";
    let dpa_name_surname = "ชื่อ-นามสกุล : " + this.form.controls["firstname"].value + " " + this.form.controls["lastname"].value + "<br>";
    let dpa_birthday = "วันเกิด : " + $("#dob").datepicker({ dateFormat: "dd/MM/yyyy" }).val() + "<br>"; //this.form.controls["birthdate"].value + "<br>";
    let dpa_accountno = "เลขที่บัญชี : " + this.form.controls["dpa_accountno"].value + "<br>";
    let emailaddress1 = "Email หลัก : " + this.form.controls["emailaddress1"].value + "<br>";
    let telephone1 = "หมายเลขโทรศัพท์ : " + this.form.controls["telephone1"].value + "<br>";
    let dpa_contact_homeno = "ที่อยู่ : " + this.form.controls["dpa_contact_homeno"].value + "<br>";
    let dpa_contact_moo = "หมู่ที่ : " + this.form.controls["dpa_contact_moo"].value + "<br>";
    let dpa_contact_street = "ถนน : " + this.form.controls["dpa_contact_street"].value + "<br>";
    let dpa_contact_subdistictname = "แขวง/ตำบล : " + this.form.controls["dpa_contact_subdistictname"].value + "<br>";
    let dpa_contact_distictname = "เขต/อำเภอ : " + this.form.controls["dpa_contact_distictname"].value + "<br>";
    let dpa_contact_provincename = "จังหวัด : " + this.form.controls["dpa_contact_provincename"].value + "<br>";
    let dpa_contact_postcodename = "รหัสไปรษณีย์ : " + this.form.controls["dpa_contact_postcodename"].value + "<br>";
    let dpa_contact_countryname = "ประเทศ : " + this.form.controls["dpa_contact_countryname"].value + "<br><br>";

    let listDataConfirm = dpa_idcard + dpa_name_surname + dpa_birthday + dpa_accountno + emailaddress1 + telephone1 + 
                          dpa_contact_homeno + dpa_contact_moo + dpa_contact_street + dpa_contact_subdistictname + 
                          dpa_contact_distictname + dpa_contact_provincename + dpa_contact_postcodename + dpa_contact_countryname;

    this.util.ConfirmDialog(listDataConfirm + "กรุณาตรวจสอบความครบถ้วนและความถูกต้องของข้อมูล ก่อนกดยืนยันการลงทะเบียน เพื่อให้สามารถเข้าใช้งานระบบได้อย่างสะดวก");
    $("#btnMainConfirm").off('click');
    $("#btnMainConfirm").click(async function () { 
        thisTs.register();
    });
  } 

  async register() {
    this.submitted = true
    this.isDup = false
    this.isSuccess = false
    this.isNotInDROS = false
    
    if (this.form.valid && this.isValidId()) {
      this.util.ShowWaiting(true)


      if (this.regisType == "n") {
        let contactId = await this.CreateContact()

        if (contactId != null && contactId.length > 0) {
          let thisTs = this

          //registerDROS
          await this.registerDROS();

          this.util.SuccessDialog("ลงทะเบียนสำเร็จ กรุณาตรวจสอบอีเมลของท่าน เพื่อยืนยันตัวตนและกำหนดรหัสผ่านในการเข้าใช้งานระบบ")
          $('#btnSuccessOK').on('click', function () {
            if (this.cookieData2 != null){
              sessionStorage.removeItem("dpa_portalThaiID");
            }
            thisTs.router.navigate(["mainmenu/index"])
          });
        }
        else {
          if (this.isForeign) {
            this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
            this.form.controls["dpa_passport"].setValue("");
            this.isForeign = false
          }
          
          
          if (this.isDup) {
            this.util.WarningDialog("อีเมลหรือบัตรประชาชนของท่าน ได้ลงทะเบียนใช้งานระบบแล้ว");
          }
          else if(this.isNotInDROS)
          {
            this.util.WarningDialog("ไม่สามารถลงทะเบียนได้ กรุณาติดต่อ DPA Call Center 1158");
          }
          else {
            this.util.ErrorDialog("ลงทะเบียนไม่สำเร็จ")
          }

        }
      }
      else {
        if (this.isValidCompany()) {
          let contactId = await this.CreateContact()

          if (contactId != null && contactId.length > 0) {

                //registerDROS
                await this.registerDROS();

            this.util.SuccessDialog("ลงทะเบียนสำเร็จ")
            let thisTs = this
            $('#btnSuccessOK').on('click', function () {
              thisTs.router.navigate(["mainmenu/login"])
            });
          }
          else {

            this.form.controls["firstname"].setValue(this.authFname)
            this.form.controls["lastname"].setValue(this.authLname)

            if (this.isForeign) {
              this.form.controls["dpa_idcard"].setValue(this.form.get("dpa_passport").value);
              this.form.controls["dpa_passport"].setValue("");
              this.isForeign = false
            }
            else {
              this.form.controls["dpa_idcard"].setValue(this.authIdcard)
            }
            if (this.isDup) {
              this.util.WarningDialog("อีเมลของท่านได้ลงทะเบียนใช้งานระบบแล้ว");
            }
            else if(this.isNotInDROS)
            {
              this.util.WarningDialog("ไม่สามารถลงทะเบียนได้ กรุณาติดต่อ DPA Call Center 1158");
            }
            else {
              this.util.ErrorDialog("ลงทะเบียนไม่สำเร็จ")
            }
          }
        }

        else {
          this.util.WarningDialog("กรุณากรอกข้อมูลให้ถูกต้อง")
        }
      }

      this.util.ShowWaiting(false)
    }
    else {
      this.util.WarningDialog("กรุณากรอกข้อมูลให้ถูกต้อง")
    }
  }

  async CreateContact() {
    try {
      var PortalUsername: string;
      if (this.Type == CustomerType.Person) {
        if (this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ")) {
          this.isForeign = true
          this.form.controls["dpa_passport"].setValue(this.form.get("dpa_idcard").value);
          this.form.controls["dpa_idcard"].setValue("");
        }
        else {
          this.form.controls["dpa_passport"].setValue("");
        }
      }
      else {
        // this.form.controls["dpa_contacttype"].setValue("3");
        this.form.controls["dpa_authorizedperson"].setValue(this.form.get("firstname").value + " " + this.form.get("lastname").value);
        this.form.controls["dpa_authorizedperson_idcard"].setValue(this.form.get("dpa_idcard").value);
        this.form.controls["dpa_authorizedperson_telephone"].setValue(this.form.get("telephone1").value);
        this.authFname = this.form.get("firstname").value
        this.authLname = this.form.get("lastname").value
        this.authIdcard = this.form.get("dpa_idcard").value
        this.form.controls["firstname"].setValue("")
        this.form.controls["lastname"].setValue("")
        this.form.controls["dpa_idcard"].setValue("")
      } 

      let dob: string = $('#dob').val()

      if (dob == null || dob.trim().length == 0) {
        this.formControl["birthdate"].setValue("")
      }
      else {
        //this.formControl["birthdate"].setValue($('#dob').data('datepicker').date.toISOString())
        this.formControl["birthdate"].setValue($("#dob").datepicker({ dateFormat: "dd/MM/yyyy" }).val())
        
      }
      let ContactID = '';
      var Res: any = await this.api.post("crmservice", "contact", this.form.value);
      if (this.util.isSuccessResponse(Res) && Res["contactid"] != null && Res["contactid"] != "") {
        ContactID = Res["contactid"]
        if (this.cookieData2 != null){
         //sessionStorage.removeItem("dpa_portalThaiID"); UpdateFlagThaid
          this.contactData = {
            contactid: ContactID
          };

         var ResFlag: any = await this.api.post("crmservice", "UpdateFlagThaid", this.contactData);
        }

        let userType = this.Type == CustomerType.Person ? "1" : "2"

        if (this.Type == CustomerType.Person) {
          this.PortalLogin = {
            firstname: this.form.get("firstname").value,
            lastname: this.form.get("lastname").value,
            usernameidno: this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ") ? this.form.get("dpa_passport").value : this.form.get("dpa_idcard").value,
            username: this.form.get("emailaddress1").value,
            password: '',
            passwordold1: '',
            isactive: "1",
            customerid: ContactID,
            createOn: null,
            createBy: null,//localStorage.getItem("AgentBank_Profile"),
            pid: null,
            modifiedOn: null,
            modifiedBy: null,
            usertype: userType,
            call_by: "2",
            url: this.util.baseUrl()
          };
        }
        else {
          this.PortalLogin = {
            firstname: this.form.controls["dpa_companyname"].value,
            lastname: "",
            usernameidno: Res["dpa_registrationid"],
            username: this.form.get("emailaddress1").value,
            password: '',
            passwordold1: '',
            isactive: "1",
            customerid: ContactID,
            createOn: null,
            createBy: null,//localStorage.getItem("AgentBank_Profile"),
            pid: null,
            modifiedOn: null,
            modifiedBy: null,
            usertype: userType,
            call_by: "2",
            url: this.util.baseUrl()
          };
        }

        Res = await this.apiService.postCustomApi("user", "InsertUser", this.PortalLogin);
        //console.log(Res);

        // let Token: any = {
        //   username: this.PortalLogin.username,
        //   usernameidno: this.PortalLogin.usernameidno,
        //   usertype: this.Type == CustomerType.Person ? "1" : "2",
        //   createBy: null//localStorage.getItem("AgentBank_Profile")
        // };
        // Res = await this.apiService.postCustomApi("user", "CreateToken", Token);
        // if (Res != null) {
        //   //let token: any = this.util.AesDecryptDictValue(Res.json())
        //   Res = await this.SendEmail(Res["token_id"]);
        // }
        // //console.log(Res);

        // //this.ResetForm();
        // if(Res.code == "200"){

        // }

        return ContactID;
      }
      else {
        //check dup
        
        if (Res["RESMSG"] != null && Res["RESMSG"] == "มีข้อมูลในระบบแล้ว") {
          this.isDup = true
        }
        else if (Res["RESMSG"] != null && Res["RESMSG"] == "ไม่มีข้อมูลDROS") {
          this.isNotInDROS = true
        }
        
        return '';
      }
    }
    catch (err) {
      //console.log(err);
      return '';
    }
  }

  async SendEmail(TokenID: string) {
    let MailObj: any = {
      contactid: this.PortalLogin.customerid,
      dpa_name: this.PortalLogin.firstname + " " + this.PortalLogin.lastname
    };

    let url = this.util.baseUrl() + "/resetPassword?id=" + TokenID

    var MailContent = "เรียน คุณ" + this.PortalLogin.firstname + " " + this.PortalLogin.lastname + "<br /><br />" +
      "   คุณได้ลงทะเบียนเพื่อเข้าใช้งานระบบ Customer Web Portal ของสถาบันคุ้มครองเงินฝาก <br />" +
      "รหัสผู้ใช้งานคือหมายเลขบัตรประจำตัวประชาชน / หมายเลขผู้เสียภาษี โปรดคลิกลิงค์ด้านล่างเพื่อตั้งรหัสผ่าน <br /><br />" +
      '<a target="_blank" href="' + url + '">' + url + "</a><br /><br />" +
      "ขอแสดงความนับถือ <br />" +
      "สถาบันคุ้มครองเงินฝาก <br />" +
      "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
      "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
      "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
      "โทร : 02-272-0300";
    MailObj.dpa_description = MailContent;
    MailObj.dpa_callby = 2
    let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
    return Res;
  }

  consentAcceptChange(target: any) {
    this.isConsentAccept = target.checked
    if (!this.isShownConsent) {
      this.showConsent()
      this.isShownConsent = true
    }
  }

  newsAllowChange(target: any) {
    this.form.controls["dpa_allowemail"].setValue(target.checked)
    this.form.controls["dpa_allowsms"].setValue(target.checked)
  }

  isValidCompany() {
    return this.formControl["dpa_companyname"].value != null &&
      this.formControl["dpa_companyname"].value.trim().length > 0 &&

      (!this.isRequiredRegisId || (this.isRequiredRegisId && this.formControl["dpa_registrationid"].value != null &&
        this.formControl["dpa_registrationid"].value.trim().length > 0))
  }

  CompanyTypeChange(value: any) {
    let Rec = this.companyTypeList.filter((a: any) => a.dpa_companytypeid == value);
    if (Rec != null && Rec.length > 0 &&
      (Rec[0]["dpa_name"] == "บริษัท จำกัด" || Rec[0]["dpa_name"] == "บริษัท(มหาชน) จำกัด" || Rec[0]["dpa_name"] == "ห้างหุ้นส่วนจำกัด")) {
      this.isRequiredRegisId = true
    }
    else {
      this.isRequiredRegisId = false
    }
  }

  numberdate(event: any) {
    const keyCode = (event.which) ? event.which : event.keyCode;
    let input: string = $('#dob').val()
    if (keyCode == 16) {
       this.isShift = true;
  }
  //Allow only Numeric Keys.
    if (((keyCode >= 48 && keyCode <= 57) || keyCode == 8 || keyCode <= 37 || keyCode <= 39 || (keyCode >= 96 && keyCode <= 105)) && this.isShift == false) {
      if ((input.length == 2 || input.length == 5) && keyCode != 8) {
          input += "/";
          $('#dob').val(input);
      }

      return true;
  }
  else {
      return false;
  }
  }

  telephoneOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {

      if (charCode == 35 || charCode == 44) {
        return true
      }
      return false;
    }
    return true;
  }

  showConsent() {
    this.isShownConsent = true
    $("#consentModal").modal('show');
  }

  personalTypeChange(value: string) {
    let type: any = this.personalTypeList.filter((p: any) => {
      return value == p.dpa_personaltypeid
    })

    if (type != null && type.length > 0) {
      this.formControl["dpa_personaltypeidname"].setValue(type[0].dpa_name)
      if (type[0].dpa_name == "ต่างชาติ") {
        this.strictIdCard = false
      }
      else {
        this.strictIdCard = true
      }
    }
    else {
      this.strictIdCard = true
    }
  }

  idCardValidator(value: any) {
    if (value && value.length == 13) {
      var total = 0;
      var iPID;
      var chk;
      var Validchk;
      iPID = value.replace(/-/g, "");
      Validchk = iPID.substr(12, 1);
      var j = 0;
      var pidcut;
      for (var n = 0; n < 12; n++) {
        pidcut = parseInt(iPID.substr(j, 1));
        total = (total + ((pidcut) * (13 - n)));
        j++;
      }

      chk = 11 - (total % 11);

      if (chk == 10) {
        chk = 0;
      } else if (chk == 11) {
        chk = 1;
      }
      if (chk == Validchk) {
        return true;
      } else {
        return false;
      }
    }
    else {
      return true;
    }
  }

  isValidId() {
    if (this.strictIdCard) {
      this.isIdCardValid = this.idCardValidator(this.formControl["dpa_idcard"].value)
      //return this.isIdCardValid //comment for test
      return true
    }
    else {
      return true
    }
  }

  numberAndAlphabetOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (!(charCode > 47 && charCode < 58) && // numeric (0-9)
      !(charCode > 64 && charCode < 91) && // upper alpha (A-Z)
      !(charCode > 96 && charCode < 123)) { // lower alpha (a-z)
      return false
    }
    return true
  }

  // bindAddress(lang: string){
  //   let v: any = this.translate.get("Select")
  //   this.ddlAddress.nativeElement.innerHtml = '<option value="">' + v.value +'</option>'
  //   this.combinedAddressList.forEach((a: any) => {
  //     if(lang == "th"){
  //       this.ddlAddress.nativeElement.innerHtml += '<option value="' + v.id + '">' + v.text + '</option>'
  //     }
  //     else{
  //       this.ddlAddress.nativeElement.innerHtml += '<option value="' + v.id + '">' + v.text_eng + '</option>'
  //     }
  //   });
  // }

  async registerDROS() {
    let idcard = this.form.get("dpa_personaltypeidname").value.includes("ต่างชาติ") ? this.form.get("dpa_passport").value : this.form.get("dpa_idcard").value;
    if(this.Type == CustomerType.Company)
    {
      idcard = this.form.get("dpa_registrationid").value
    }
    let para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false&CRM06=true";
    let tmp: any = await this.apiService.get("crmservice", "contactDros", para);
    if (!this.util.IsNullOrUndefined(tmp.CRM06)) {
      let UID = tmp.CRM06.UID;
      let SubdistictCode: string = "";
      let PostalName: string = "";
      let SubdistictObj = await this.apiService.postCustomApi("master", "Subdistrict", { id: this.form.get("dpa_contact_subdistict").value });
      let PostalObj = await this.apiService.postCustomApi("master", "Postalcode", { id: this.form.get("dpa_contact_postcode").value });
      if (!this.util.IsNullOrUndefined(SubdistictObj)) { SubdistictCode = SubdistictObj[0].dpa_code; }
      if (!this.util.IsNullOrUndefined(PostalObj)) { PostalName = PostalObj[0].dpa_name; }
      let arrAddr: any = [];
      let rowAddr: any = {
        addressType: "2",
        addressNo: this.form.get("dpa_contact_homeno").value,
        villageName: null,
        floor: null,
        mooNo: this.form.get("dpa_contact_moo").value,
        soiName: null,
        streetName: this.form.get("dpa_contact_street").value,
        locationCode: SubdistictCode,
        zipcode: PostalName
      }

     let birthdateYYYYMMDD = ""
     if(this.form.get("birthdate").value != "")
     {
      birthdateYYYYMMDD = moment(this.form.get("birthdate").value).format("YYYY/MM/DD") ;
     }

      arrAddr.push(rowAddr);
      let rowSave: any = {
        uid: UID,
        idNo: idcard,
        title: null,
        firstName: this.Type == CustomerType.Person ? this.form.get("firstname").value : this.form.controls["dpa_companyname"].value,
        lastName: this.Type == CustomerType.Person ? this.form.get("lastname").value : "",
        birthdate: birthdateYYYYMMDD ,
        mobileNo: this.Type == CustomerType.Person ? this.form.get("telephone1").value : this.form.get("dpa_authorizedperson_telephone").value,
        email: this.form.get("emailaddress1").value,
        address: arrAddr
      }
      
      let Res = await this.apiService.post("DROS", "register", rowSave);
      


    }

  }

}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts